import type { AuthConfig, AuthUser } from "./index";

export type AuthConfigDefaults = {
  authority: string;
  audience: string;
  clientId: string;
  tenantId: string;
  organizationId: string;
  actorId: string;
  customerId?: string;
  appName: string;
  roles: string[];
  scopes: string[];
  siteOrigin?: string;
  resolveOrigin?: () => string;
};

export function resolveAuthOrigin(siteOrigin?: string): string {
  if (typeof window !== "undefined") {
    return window.location.origin;
  }

  return siteOrigin ?? "http://localhost:5173";
}

export function createDefaultAuthConfig(options: AuthConfigDefaults): AuthConfig {
  const origin = options.resolveOrigin ? options.resolveOrigin() : resolveAuthOrigin(options.siteOrigin);
  const defaultUser: Partial<AuthUser> = {
    id: options.actorId,
    partId: options.actorId,
    customerId: options.customerId,
    email: `${options.actorId}@stenpro.local`,
    name: `${options.appName} Developer`,
    tenantId: options.tenantId,
    organizationId: options.organizationId,
    roles: options.roles,
    scopes: options.scopes,
  };

  return {
    authority: options.authority,
    audience: options.audience,
    clientId: options.clientId,
    redirectUri: origin,
    postLogoutRedirectUri: origin,
    tenantId: options.tenantId,
    organizationId: options.organizationId,
    defaultUser,
    defaultScopes: options.scopes,
  };
}
